import { useTranslation } from 'react-i18next';
import { S, Icon, formatCHF } from '../regureStyles';

const MetricCards = ({ totalOutstanding, totalOverdue, totalPaid }) => {
  const { t } = useTranslation();
  const cards = [
    { label: t('screens.invoicing.metricOutstanding'), value: formatCHF(totalOutstanding), color: S.burgundy, icon: 'receipt' },
    { label: t('screens.invoicing.metricOverdue'), value: formatCHF(totalOverdue), color: '#ef4444', icon: 'alert-circle' },
    { label: t('screens.invoicing.metricPaidYtd'), value: formatCHF(totalPaid), color: '#10b981', icon: 'check-circle' },
  ];
  return (
    <div
      style={{
        padding: '16px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.6)',
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 12,
      }}
    >
      {cards.map(m => (
        <div
          key={m.label}
          style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: '#fff', border: `1px solid ${S.borderLight}`, borderRadius: 12 }}
        >
          <div style={{ width: 36, height: 36, borderRadius: 10, background: m.color + '14', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name={m.icon} color={m.color} size={18} />
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8 }}>{m.label}</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: m.color }}>{m.value}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricCards;
